import type { ISakskategori } from './ISakskategori';

export class Sakskategori implements ISakskategori {
    public static parseObject(obj: ISakskategori): Sakskategori {
        try {
            return new Sakskategori(obj);
        } catch (e) {
            throw new Error('Not able to parse object');
        }
    }

    readonly id: ISakskategori['id'];
    readonly sakskategoriId: ISakskategori['sakskategoriId'];
    readonly parent: ISakskategori['parent'];
    readonly kode?: ISakskategori['kode'];
    readonly navn: ISakskategori['navn'];
    readonly system: ISakskategori['system'];
    readonly type: ISakskategori['type'];
    readonly children: ISakskategori['children'] = [];

    constructor(obj: ISakskategori) {
        this.id = obj.id;
        this.sakskategoriId = obj.sakskategoriId;
        this.parent = obj.parent;
        this.kode = obj.kode;
        this.navn = obj.navn;
        this.system = obj.system;
        this.type = obj.type;
        this.children = obj.children;
    }

    public toOption = () => ({
        label: this.navn,
        value: this.id,
    });

    public getChildren = () =>
        this.children.map((child) => Sakskategori.parseObject(child));
}
